module.exports = __webpack_public_path__ + "media/effects-6.e808e27c.webm";